const cache=new Map();
async function locate(person = {}){
 const address=[person.address,person.postCode || person.postalCode,person.town || person.city].filter(Boolean).join(' ').trim();
 if(!address)return null;
 if(!cache.has(address))cache.set(address,fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(address)}&limit=1`).then(response=>response.json()).then(data=>data.features?.[0]?.geometry?.coordinates || null).catch(()=>null));
 return cache.get(address);
}
export async function candidateDistances(client,candidates){
 const origin=await locate(client);const distances={};if(!origin)return distances;
 let index=0;
 await Promise.all(Array.from({length:Math.min(2,candidates.length)},async()=>{
  while(index<candidates.length){const candidate=candidates[index++];const point=await locate(candidate);if(!point)continue;
   const rad=value=>value*Math.PI/180;
   const h=Math.sin(rad(point[1]-origin[1])/2)**2+Math.cos(rad(origin[1]))*Math.cos(rad(point[1]))*Math.sin(rad(point[0]-origin[0])/2)**2;
   distances[String(candidate._id)]=6371*2*Math.asin(Math.sqrt(Math.min(1,h)));
  }
 }));return distances;
}
